/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
import axios from 'axios';
import { 
    FETCH_GTD_LOGS_SUCCESS,
    FETCHING_GTD_LOGS,
    FETCH_SELECTED_LOG_INFORMATION,
    FETCHING_SELECTED_LOG_INFORMATION
} from './LogConstants';

const logsUrl = 'utm/v1/logs';

const fetchingGTDLogs = () => ({ type: FETCHING_GTD_LOGS });
const fetchGtdReqRespSuccess = gtdLogs => ({ type: FETCH_GTD_LOGS_SUCCESS, gtdLogs});
const fetchingSelectedLogInformation = () => ({ type: FETCHING_SELECTED_LOG_INFORMATION });
const fetchSelectedLogInformationSuccess = logInformation => ({ type: FETCH_SELECTED_LOG_INFORMATION, logInformation});

export const fetchGTDLogs = (headerId) => dispatch => {
    dispatch(fetchingGTDLogs());
    axios.get(`${logsUrl}/headers/${headerId}`).then( response => {
        let logsArray = response.data.data;

        if ( logsArray.length > 0 ) {
        dispatch(fetchGetReqsResp(logsArray[0].id));
        }
        
        dispatch(fetchGtdReqRespSuccess(logsArray));
    });
};

    export const fetchGetReqsResp = (gtdId) => dispatch => {
    let gtdReqRespInformation = {};
    dispatch(fetchingSelectedLogInformation());
    axios.get(`${logsUrl}/${gtdId}?type=RESPONSE`)
        .then( response => {      
        gtdReqRespInformation.response = response.data.data;
        }).then( () => {
        axios.get(`${logsUrl}/${gtdId}?type=REQUEST`)
            .then( request => {
            gtdReqRespInformation.request = request.data.data;
            dispatch(fetchSelectedLogInformationSuccess(gtdReqRespInformation));
            });
        });
};


// WEBPACK FOOTER //
// ./src/redux/logs/LogActions.js